import { createSelector } from 'reselect';
import { ArsenalArmy } from '@Models';
import { ArsenalArmyView } from '@Selectors/arsenal/make/view/ArsenalArmyView';
import { getArsenalArmies } from '@Selectors/arsenal/selector/getArsenalArmies';
import { createSteps } from '@Selectors/arsenal/createSteps';

export const myArsenalArmiesPresenter = createSelector(
  [getArsenalArmies],
  (arsenalArmies): Array<ArsenalArmyView> => {
    return [...arsenalArmies]
      .sort((a: ArsenalArmy, b: ArsenalArmy) => a.name.localeCompare(b.name))
      .map(
        (item) =>
          ({
            id: item.id,
            name: item.name,
            logo: item.largeLogo,
            units: [],
            readings: createSteps(item?.steps ?? []),
          }) satisfies ArsenalArmyView as ArsenalArmyView,
      );
  },
);
